import { render, staticRenderFns } from "./ImportPacs.vue?vue&type=template&id=12388b9a&scoped=true"
import script from "./ImportPacs.vue?vue&type=script&lang=js"
export * from "./ImportPacs.vue?vue&type=script&lang=js"
import style0 from "./ImportPacs.vue?vue&type=style&index=0&id=12388b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12388b9a",
  null
  
)

export default component.exports